import type { IFieldValue } from '@/components/form/types';

export const rules = {
  empty: (value?: IFieldValue) => (value !== undefined && value !== '') || 'Required',
  image: (value?: IFieldValue) => {
    return (
      (value !== undefined &&
        (value.startsWith('image/png') ||
          value.startsWith('image/jpeg') ||
          value.startsWith('image/jpg') ||
          value.startsWith('image/gif'))) ||
      'Only PNG, JPG, or GIF images'
    );
  },

  fogoLimits: (value?: IFieldValue) => {
    if (value === undefined) {
      return true;
    }
    if (value === '') {
      return true;
    }
    if (isNaN(Number(value))) {
      return 'Integers only';
    }
    return Number(value) >= 0 || 'Invalid amount';
  },
  name: (value?: IFieldValue) => {
    return (value !== undefined && value.length < 50) || 'Max 50 characters';
  },
  description: (value?: IFieldValue) => {
    return (value !== undefined && value.length < 250) || 'Max 250 characters';
  },
  symbol: (value?: IFieldValue) => {
    return (value !== undefined && value.length < 10) || 'Max 10 characters';
  },
  website: (value?: IFieldValue) => {
    const regex = /^https?:\/\/[^\s/$.?#].[^\s]*$/;

    return value === undefined || value.length === 0 || regex.test(value) || 'Invalid URL';
  },
  twitter: (value?: IFieldValue) => {
    const regex = /^https?:\/\/(www\.)?x\.com\/[A-Za-z0-9_]{1,15}\/?$/;

    return value === undefined || value.length === 0 || regex.test(value) || 'Invalid URL';
  },
  telegram: (value?: IFieldValue) => {
    const regex = /^https?:\/\/(t\.me|telegram\.me)\/[A-Za-z0-9_]{5,32}\/?$/;

    return value === undefined || value.length === 0 || regex.test(value) || 'Invalid URL';
  },
  tiktok: (value?: IFieldValue) => {
    const regex = /^https?:\/\/(www\.)?tiktok\.com\/@[A-Za-z0-9_.]{2,24}\/?$/;

    return value === undefined || value.length === 0 || regex.test(value) || 'Invalid URL';
  },
  number: (value?: IFieldValue) => {
    const regex = /^\d+(\.\d+)?$/;

    return (
      value === undefined ||
      value.length === 0 ||
      regex.test(value) ||
      'Amount must be greater than zero'
    );
  },
  amount: (value?: IFieldValue) => {
    return (value !== undefined && Number(value) > 0) || 'Invalid amount';
  },
  slippage: (value?: IFieldValue) => {
    const MIN_SLIPPAGE = 0.01;
    const MAX_SLIPPAGE = 50;
    const numValue = Number(value);

    if (value === undefined || value === '') return 'Required';
    if (isNaN(numValue)) return 'Must be a number';
    if (numValue < MIN_SLIPPAGE) return `Min ${MIN_SLIPPAGE}%`;
    if (numValue > MAX_SLIPPAGE) return `Max ${MAX_SLIPPAGE}%`;
    return true;
  },
};
